import Movement from "./movement";

export default class Dribble extends Movement {
  render = function() {
    this.setupContext();

    const s = this.context.scale;

    this.context.strokeStyle = "rgba(0, 0, 0, 1)";
    this.context.fillStyle = "rgba(0, 0, 0, 1)";

    this.renderMovement();
    this.renderArrow();

    if (this.selected) {
      for (let p in this.modifiers) {
        const modifier = this.modifiers[p];
        const highlighted = p == this.highlightedModifier;
        this.renderModifier(modifier.origin[0] * s, modifier.origin[1] * s, modifier.radius * s, highlighted)
      }
    }

    this.resetContext();
  }

  renderMovement = function () {
    const s = this.context.scale;

    this.context.beginPath();
    
    let currentX = this.x() / s;
    let currentY = this.y() / s;

    for (const p in this.points) {
      const point = this.points[p];
      
      this.drawWavyQuadraticCurve(
        currentX,
        currentY,
        point[0], 
        point[1],
        point[2], 
        point[3],
        s
      );
      
      currentX = point[2];
      currentY = point[3];
    }

    this.context.stroke();

    if (this.selected) {
      for (const p in this.points) {
        const point = this.points[p];

        this.renderHighlight(point[2] * s, point[3] * s, false);
        this.renderHighlight(point[0] * s, point[1] * s, true);
      }
    }
  }

  drawWavyQuadraticCurve = function(x0, y0, x1, y1, x2, y2, scale) {
    const d1 = Math.sqrt((x1 - x0) ** 2 + (y1 - y0) ** 2);
    const d2 = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    const approxLength = d1 + d2;
    
    const waveAmplitude = 2;
    const wavelength = 15;
    const steps = Math.max(Math.floor(approxLength / 1.2), 20);

    this.context.moveTo(x0 * scale, y0 * scale);
    
    let accumulatedDistance = 0;
    let prevX = x0;
    let prevY = y0;
    
    for (let i = 1; i < steps; i++) {
      const t = i / steps;
      
      const mt = 1 - t;
      const mt2 = mt * mt;
      const t2 = t * t;
      
      const x = mt2 * x0 + 2 * mt * t * x1 + t2 * x2;
      const y = mt2 * y0 + 2 * mt * t * y1 + t2 * y2;
      
      const segmentDist = Math.sqrt((x - prevX) ** 2 + (y - prevY) ** 2);
      accumulatedDistance += segmentDist;
    
      const dx = 2 * mt * (x1 - x0) + 2 * t * (x2 - x1);
      const dy = 2 * mt * (y1 - y0) + 2 * t * (y2 - y1);

      const tangentAngle = Math.atan2(dy, dx);
      const perpAngle = tangentAngle + Math.PI / 2;
      
      const waveOffset = Math.sin((accumulatedDistance / wavelength) * 2 * Math.PI) * waveAmplitude;
      const finalX = (x + Math.cos(perpAngle) * waveOffset) * scale;
      const finalY = (y + Math.sin(perpAngle) * waveOffset) * scale;
      
      this.context.lineTo(finalX, finalY);
      
      prevX = x;
      prevY = y;
    }

    this.context.lineTo(x2 * scale, y2 * scale);
  }

  renderModifier = function(x, y, r, selected) {
    this.context.beginPath();
    this.context.strokeStyle = "rgba(255, 255, 0, 0.6)";
    this.context.lineWidth = 2;
    this.context.arc(x, y, r, 0, 2 * Math.PI, true);
    this.context.stroke();

    if (selected) {
      this.context.beginPath();
      this.context.lineWidth = 1;
      this.context.strokeStyle = "rgba(255, 255, 255, 0.5)";
      this.context.rect(x-r-5, y-r-5, r*2+10, r*2+10);
      this.context.stroke();
    }
  }
}

